module.exports = __webpack_public_path__ + "img/18000.d81f9bfa.jpg";